import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Preloader from 'src/components/Preloader';
import useStyles from '../../styles';

const DeleteKamDialog = ({ open, handleClose, handleSubmit, isLoading }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.dialogRoot }}
      open={open}
      keepMounted
      style={{ marginBottom: '1.5rem' }}
    >
      <DialogTitle className={classes.header} id="form-delete-kam">
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={handleClose}
          className={classes.closeIcon}
          disabled={isLoading}
        >
          <CloseIcon />
        </IconButton>
        <Typography className={classes.header} color="primary" variant="h2">
          {t('DISTRIBUTORS_VIEW.AGENTS.DELETE_KAM')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Preloader />
        ) : (
          <>
            <Alert severity="error" sx={{ marginBottom: 2 }}>
              {t('DISTRIBUTORS_VIEW.AGENTS.DELETE_KAM_DESCRIPTION')}
            </Alert>
            <Grid
              container
              style={{ marginBottom: '1.5rem' }}
              direction="column"
              alignItems="stretch"
            >
              <Grid item className={classes.buttons}>
                <Button
                  className={clsx(classes.label, classes.buttons)}
                  onClick={handleSubmit}
                  color="primary"
                  variant="outlined"
                >
                  {t('COMMON.ACCEPT')}
                </Button>
              </Grid>
              <Grid item className={classes.buttons}>
                <Button
                  className={clsx(classes.outlined, classes.buttons)}
                  onClick={handleClose}
                  color="primary"
                  variant="outlined"
                >
                  {t('COMMON.CANCEL')}
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

DeleteKamDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default DeleteKamDialog;
